import Experience from "./Experience/Experience.js";
import emailjs from "@emailjs/browser";
import { isMobile } from "./Experience/Utils/Mobile.js";
import {
  openPanel,
  closePanel,
  getOpenPanel,
  trapFocus,
} from "./Experience/Utils/Panels.js";
import { loadDebugUI } from "./Experience/Utils/Debug.js";

// Start even if the debug UI fails to load
loadDebugUI()
  .catch(() => {})
  .then(() => {
    new Experience(document.querySelector("canvas.webgl"));
  });

document.addEventListener("DOMContentLoaded", () => {
  const mobileContainer = document.querySelector(".mobile-container");

  if (isMobile()) {
    mobileContainer.style.display = "flex";
  }

  document
    .getElementById("mobile-button")
    .addEventListener("click", function () {
      mobileContainer.style.display = "none";
    });

  const audio = document.getElementById("background-audio");
  const playPauseButton = document.getElementById("play-pause-button");
  audio.volume = 0.1;
  audio.muted = false;

  const playIcon = "fa-solid fa-volume-high fa-2xl";
  const pauseIcon = "fa-solid fa-volume-xmark fa-2xl";

  // Keep the icon in sync with what the audio is actually doing
  // (autoplay may or may not be allowed by the browser)
  const updateAudioButton = () => {
    const playing = !audio.paused;
    playPauseButton.innerHTML = `<i class="${playing ? playIcon : pauseIcon}"></i>`;
    playPauseButton.setAttribute(
      "aria-label",
      playing ? "Pause music" : "Play music",
    );
  };
  audio.addEventListener("play", updateAudioButton);
  audio.addEventListener("pause", updateAudioButton);
  updateAudioButton();

  playPauseButton.addEventListener("click", () => {
    if (audio.paused) {
      audio.play().catch(() => {});
    } else {
      audio.pause();
    }
  });

  document.querySelectorAll(".close-button").forEach((button) => {
    button.addEventListener("click", () => {
      closePanel(button.closest(".global-div"));
    });
  });

  // Navigation menu: an icon that opens a full-screen overlay of the panels
  const nav = document.querySelector(".site-nav");
  const navToggle = nav.querySelector(".nav-toggle");
  const navList = nav.querySelector(".nav-list");
  const isMenuOpen = () => nav.classList.contains("open");
  const setMenuOpen = (open) => {
    // Items vanish with the overlay, so don't leave keyboard focus on one
    if (!open && navList.contains(document.activeElement)) {
      navToggle.focus({ preventScroll: true });
    }
    nav.classList.toggle("open", open);
    document.documentElement.classList.toggle("menu-open", open);
    navToggle.setAttribute("aria-expanded", String(open));
    navToggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    navToggle.innerHTML = `<i class="fa-solid ${open ? "fa-xmark" : "fa-bars"} fa-2xl" aria-hidden="true"></i>`;
  };

  navToggle.addEventListener("click", () => {
    setMenuOpen(!isMenuOpen());
  });
  // Clicking the dimmed backdrop (not an item) closes the menu
  navList.addEventListener("click", (event) => {
    if (event.target === navList) setMenuOpen(false);
  });
  nav.querySelectorAll("[data-panel]").forEach((button) => {
    button.addEventListener("click", () => {
      setMenuOpen(false);
      // The item is hidden once the menu closes, so return focus to the
      // Menu button when the panel closes
      navToggle.focus({ preventScroll: true });
      const room = new Experience().world?.room;
      if (room) {
        room.showPanel(button.dataset.panel);
      } else {
        openPanel(document.getElementById(button.dataset.panel));
      }
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      setMenuOpen(false);
      closePanel(getOpenPanel());
    } else if (event.key === "Tab") {
      trapFocus(event, isMenuOpen() ? nav : getOpenPanel());
    }
  });

  // Hide the scroll hint for good once the visitor starts scrolling
  const scrollHint = document.querySelector(".scroll-hint");
  const hideScrollHint = () => {
    if (window.scrollY > 50) {
      scrollHint.classList.add("dismissed");
      window.removeEventListener("scroll", hideScrollHint);
    }
  };
  window.addEventListener("scroll", hideScrollHint);
  emailjs.init("KHrAx8Y1-D9XN07ly");

  const form = document.getElementById("contact-form");
  const submitButton = document.getElementById("submit-button");
  const formMessage = document.getElementById("form-message");
  const showFormMessage = (text, color) => {
    formMessage.textContent = text;
    formMessage.style.color = color;
  };

  if (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();

      // Prevent double submissions while sending
      submitButton.disabled = true;
      submitButton.textContent = "Sending…";
      showFormMessage("", "");

      emailjs
        .sendForm("contact_service", "contact_form", this)
        .then(
          () => {
            showFormMessage("Message sent successfully!", "green");
            form.reset();
          },
          () => {
            showFormMessage(
              "Failed to send the message. Please try again later.",
              "red",
            );
          },
        )
        .finally(() => {
          submitButton.disabled = false;
          submitButton.textContent = "Send Message";
        });
    });
  }

  const artBtn = document.getElementById("art-projects-btn");
  const devBtn = document.getElementById("dev-projects-btn");
  const artProjects = document.getElementById("art-projects");
  const devProjects = document.getElementById("dev-projects");

  // Art Projects Button Click
  artBtn.addEventListener("click", function () {
    artProjects.classList.remove("hidden");
    devProjects.classList.add("hidden");
    artBtn.classList.add("active");
    devBtn.classList.remove("active");
  });

  // Dev Projects Button Click
  devBtn.addEventListener("click", function () {
    devProjects.classList.remove("hidden");
    artProjects.classList.add("hidden");
    devBtn.classList.add("active");
    artBtn.classList.remove("active");
  });
});
